'use client'

import { useState, useCallback } from 'react'
import { useRouter } from 'next/navigation'
import { useAuth } from '@/Auth/useAuth'
import { Button } from '@/General/Button'
import { LoginModal } from '@/MainLayout/Header/TopMenu/LoginModal'

export const LoginToOrdersButton = () => {
  const { isAuthenticated, isResolved } = useAuth()
  const [isLoginOpen, setIsLoginOpen] = useState(false)
  const router = useRouter()

  const handleLoginSuccess = useCallback(() => {
    router.push('/account/orders')
  }, [router])

  const handleClick = useCallback(() => {
    if (!isResolved) return
    if (isAuthenticated) {
      router.push('/account/orders')
    } else {
      setIsLoginOpen(true)
    }
  }, [isAuthenticated, isResolved, router])

  return (
    <>
      <LoginModal
        isLoginOpen={isLoginOpen}
        setIsLoginOpen={setIsLoginOpen}
        message="Log in to access your orders"
        onLoginSuccess={handleLoginSuccess}
        redirectTo="/account/orders"
      />
      <Button className="my-4" onClick={handleClick} disabled={!isResolved}>
        Log in to your orders area
      </Button>
    </>
  )
}
